module.exports = __webpack_public_path__ + "media/images/icons/sort-b0179bf65d5f1c70c251e133e32826ca.svg";